'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var appTypes = require('../../types/appTypes');
var RadioIcon = require('./RadioIcon');

/**
 * CheckBoxItem
 * @author mxj
 * @createDate 2016-8-3
 **/

var RadioItem = React.createClass({

  _doPaint() {
    var selfDom = ReactDOM.findDOMNode(this);
    var parentDom;
    var measureSize;

    parentDom = selfDom.parentElement;
    while (!parentDom && (parentDom.id !== this.props.controlID)) {
      parentDom = parentDom.parentElement;
    }

    if (parentDom) {
      measureSize = AutoSizeHelper.getComAutoSize(this.props);
      parentDom.style.width = (measureSize.width + 20) + 'px';
    }
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.text !== this.props.text) {
      this.isInvalid = true;
    }
  },

  componentDidUpdate: function () {
    this._doPaint();
  },

  componentDidMount: function () {
    this._doPaint();
  },


  render: function () {
    this.isLeftText = this.props.textDirection === appTypes.TextDirection.LEFT;
    var divStyle;
    var textStyle;
    var size = parseInt(this.props.size, 10) || 16;
    var gap = parseInt(this.props.gap, 10) || 0;

    divStyle = {
      width: '100%',
      height: '100%',
      opacity: this.props.isDisabled ? 0.6 : 1,
      overflow: 'hidden',
      pointerEvents: this.props.isDisabled ? 'none' : 'auto'
    };

    textStyle = {
      left: this.isLeftText ? 0 : (size + gap),
      top: 0,
      height: styleHelper.getHeight(this.props),
      width: styleHelper.getWidth(this.props) - size - gap,
      lineHeight: styleHelper.getHeight(this.props) + 'px',
      position: 'absolute',
      textDecoration: 'inherit',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    };
    styleHelper.StyleUtil(this.props).default(divStyle).text().align();
    return (
      <div style={divStyle} onClick={this._onClick}>
        <RadioIcon {...{
          enabled: _.isUndefined(this.props.enabled) ? true : this.props.enabled,
          size: size,
          color: this.props.borderColor,
          left: this.props.textDirection === appTypes.TextDirection.RIGHT ? 0 : styleHelper.getWidth(this.props) - (this.props.size || 16),
          top: (styleHelper.getHeight(this.props) - (this.props.size || 16)) / 2,
          isSelected: this.props.isSelected,
          borderColor: styleHelper.getBorderColor(this.props)
        }}/>
        <div style={textStyle}>
          <label>{this.props.text}</label>
        </div>
      </div>
    );
  },

  _onClick: function () {
    if (!this.props.isDisabled) {
      if (this.props.onSelected) {
        this.props.onSelected();
      }
    }
  }
});

module.exports = RadioItem;


// WEBPACK FOOTER //
// ./src/views/common/RadioItem.jsx